/**
 * Animated FAQ accordion using Web Animations API.
 * Native <details> doesn't animate on open; this provides smooth transitions.
 */
(function () {
  const DURATION = 350;
  const EASING = 'ease-out';

  function initAccordion(el) {
    const summary = el.querySelector('.gewinnspiel-faq__question');
    const content = el.querySelector('.gewinnspiel-faq__answer');
    if (!summary || !content) return;

    let animation = null;
    let isClosing = false;
    let isExpanding = false;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function shrink() {
      isClosing = true;
      const startHeight = el.offsetHeight;
      const endHeight = summary.offsetHeight;

      if (animation) animation.cancel();

      if (!prefersReducedMotion.matches) {
        animation = el.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: DURATION, easing: EASING }
        );
        animation.onfinish = () => onAnimationFinish(false);
        animation.oncancel = () => (isClosing = false);
      } else {
        onAnimationFinish(false);
      }
    }

    function expand() {
      isExpanding = true;
      const startHeight = el.offsetHeight;
      const endHeight = summary.offsetHeight + content.offsetHeight;

      if (animation) animation.cancel();

      if (!prefersReducedMotion.matches) {
        animation = el.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: DURATION, easing: EASING }
        );
        animation.onfinish = () => onAnimationFinish(true);
        animation.oncancel = () => (isExpanding = false);
      } else {
        onAnimationFinish(true);
      }
    }

    function onAnimationFinish(open) {
      el.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      el.style.height = '';
      el.style.overflow = '';
    }

    function onClick(e) {
      e.preventDefault();
      el.style.overflow = 'hidden';

      if (isClosing || !el.open) {
        el.style.height = el.offsetHeight + 'px';
        el.open = true;
        requestAnimationFrame(() => expand());
      } else if (isExpanding || el.open) {
        shrink();
      }
    }

    summary.addEventListener('click', onClick);
  }

  function init() {
    document.querySelectorAll('.gewinnspiel-faq__item').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
